import { convertRgbaToHex, getFileBlob } from "utils"
import { FONT_TYPES, WIDTH_TYPES, DEFAULT_FONT } from "./constants"

export const mapAPIresponseToForm = (apiResponse = {}) => ({
  loadingScreen: {
    background: {
      bgImage: {
        originalImage: apiResponse.loading_screen_bg_image_url,
        editedImage: apiResponse.loading_screen_bg_image_updated_url,
      },
      deleteBgImage: false,
      bgColor: convertRgbaToHex(apiResponse.loading_screen_bg_color),
    },
    logo: {
      logoImage: {
        originalImage: apiResponse.loading_screen_logo_url,
        editedImage: apiResponse.loading_screen_logo_updated_url,
      },
      deleteLogoImage: false,
      widthType: getWithType(apiResponse.loading_screen_logo_width_type),
      widthInPixel: apiResponse.loading_screen_logo_width_px || 250,
      widthInPercent: apiResponse.loading_screen_logo_width_percentage || 59,
      logoPlacement: apiResponse.loading_screen_logo_placement,
    },
  },
  logo: {
    widthType: getWithType(apiResponse.app_logo_width_type),
    widthInPixel: apiResponse.app_logo_width_px || 300,
    widthInPercent: apiResponse.app_logo_width_percentage || 90,
    logoPlacement: apiResponse?.app_logo_placement || 1,
    logoImage: {
      originalImage: apiResponse.app_logo_url,
      editedImage: apiResponse.app_logo_updated_url,
    },
    deleteLogoImage: false,
  },
  button: {
    fontType: apiResponse.font_file_uploaded
      ? FONT_TYPES.FILE
      : FONT_TYPES.PREDEFINED,
    font: apiResponse.button_font_family || DEFAULT_FONT,
    fontFile: { dataURI: apiResponse.font_file_uploaded?.url },
    deleteFontFile: false,
    fontSize: apiResponse.button_font_size || 12,
    fontColor: apiResponse.button_font_color
      ? convertRgbaToHex(apiResponse.button_font_color)
      : "#000000",
    buttonColor: convertRgbaToHex(apiResponse.button_color),
    buttonText: apiResponse.button_text || "Sign Up",
    verticalOffset: apiResponse.button_offset_left,
    horizontalOffset: apiResponse.button_offset_top,
  },
  linkExplore: {
    linkColor: apiResponse.text_color
      ? convertRgbaToHex(apiResponse.text_color)
      : "#000000",
    font: apiResponse?.title_font || "Arial",
    fontSize: apiResponse?.title_size || 26,
  },
  bottomLogo: {
    widthType: getWithType(apiResponse.bottom_logo_width_type),
    isLogoEnabled: convertAPIBool(apiResponse.bottom_logo_enabled),
    widthInPixel: apiResponse.bottom_logo_width_px || 150,
    widthInPercent: apiResponse.bottom_logo_width_percentage || 50,
    logoImage: {
      originalImage: apiResponse.bottom_logo_url,
      editedImage: apiResponse.bottom_logo_updated_url,
    },
    deleteLogoImage: false,
  },
  background: {
    bgColor: convertRgbaToHex(apiResponse.app_bg_color),
    bgImage: {
      originalImage: apiResponse.app_bg_image_url,
      editedImage: apiResponse.app_bg_image_updated_url,
    },
    deleteBgImage: false,
  },
})

export const mapFormToAPI = (values = {}) => ({
  loading_screen_bg_image: getFileBlob(
    values.loadingScreen?.background &&
      values.loadingScreen?.background?.bgImage &&
      values.loadingScreen?.background?.bgImage?.originalImage
  ),
  loading_screen_bg_image_updated: getFileBlob(
    values.loadingScreen?.background &&
      values.loadingScreen?.background?.bgImage &&
      values.loadingScreen?.background?.bgImage?.editedImage
  ),
  delete_loading_bg_image: convertBool(
    values.loadingScreen?.background &&
      values.loadingScreen?.background?.deleteBgImage
  ),
  loading_screen_bg_color:
    values.loadingScreen?.background &&
    values.loadingScreen?.background?.bgColor,
  loading_screen_logo: getFileBlob(
    values.loadingScreen?.logo &&
      values.loadingScreen?.logo?.logoImage &&
      values.loadingScreen?.logo?.logoImage?.originalImage
  ),
  loading_screen_logo_updated: getFileBlob(
    values.loadingScreen?.logo &&
      values.loadingScreen?.logo?.logoImage &&
      values.loadingScreen?.logo?.logoImage?.editedImage
  ),
  delete_loading_logo: convertBool(
    values.loadingScreen?.logo && values.loadingScreen?.logo?.deleteLogoImage
  ),
  loading_screen_logo_width_type: getWidthTypeId(
    values.loadingScreen?.logo && values.loadingScreen?.logo?.widthType
  ),
  loading_screen_logo_width_px:
    values.loadingScreen?.logo && values.loadingScreen?.logo?.widthInPixel,
  loading_screen_logo_width_percentage:
    values.loadingScreen?.logo && values.loadingScreen?.logo?.widthInPercent,
  loading_screen_logo_placement:
    values.loadingScreen?.logo && values.loadingScreen?.logo?.logoPlacement,
  app_bg_image: getFileBlob(
    values.background &&
      values.background.bgImage &&
      values.background.bgImage.originalImage
  ),
  app_bg_image_updated: getFileBlob(
    values.background &&
      values.background.bgImage &&
      values.background.bgImage.editedImage
  ),
  delete_app_bg_image: convertBool(
    values.background && values.background.deleteBgImage
  ),
  app_bg_color: values.background && values.background.bgColor,
  app_logo: getFileBlob(
    values.logo && values.logo.logoImage && values.logo.logoImage.originalImage
  ),
  app_logo_updated: getFileBlob(
    values.logo && values.logo.logoImage && values.logo.logoImage.editedImage
  ),
  delete_app_logo: convertBool(values.logo && values.logo.deleteLogoImage),
  app_logo_width_type: getWidthTypeId(values.logo && values.logo.widthType),
  app_logo_width_px: values.logo && values.logo.widthInPixel,
  app_logo_width_percentage: values.logo && values.logo.widthInPercent,
  app_logo_placement: values.logo && values.logo.logoPlacement,
  button_color: values.button && values.button.buttonColor,
  button_font_family: values.button && values.button.font,
  ...(values.button.deleteFontFile
    ? {
        font_file: getFileBlob(
          values.button &&
            values.button.fontFile &&
            values.button.fontFile.dataURI
        ),
      }
    : {}),
  button_text: values.button && values.button.buttonText,
  delete_font_file: convertBool(values.button && values.button.deleteFontFile),
  button_font_size: values.button && values.button.fontSize,
  button_font_color: values.button && values.button.fontColor,
  button_offset_left: values.button && values.button.horizontalOffset,
  button_offset_top: values.button && values.button.verticalOffset,
  text_color: values.linkExplore && values.linkExplore.linkColor,
  bottom_logo_enabled: convertBool(
    values.bottomLogo && values.bottomLogo.isLogoEnabled
  ),
  bottom_logo: getFileBlob(
    values.bottomLogo &&
      values.bottomLogo.logoImage &&
      values.bottomLogo.logoImage.originalImage
  ),
  bottom_logo_updated: getFileBlob(
    values.bottomLogo &&
      values.bottomLogo.logoImage &&
      values.bottomLogo.logoImage.editedImage
  ),
  delete_bottom_logo: convertBool(
    values.bottomLogo && values.bottomLogo.deleteLogoImage
  ),
  bottom_logo_width_type: getWidthTypeId(
    values.bottomLogo && values.bottomLogo.widthType
  ),
  bottom_logo_width_px: values.bottomLogo && values.bottomLogo.widthInPixel,
  bottom_logo_width_percentage:
    values.bottomLogo && values.bottomLogo.widthInPercent,
})

const getWithType = widthTypeId => {
  switch (widthTypeId) {
    case 1:
      return WIDTH_TYPES.PIXEL
    case 2:
      return WIDTH_TYPES.PERCENTAGE
    default:
      return WIDTH_TYPES.FULL_WIDTH
  }
}

const getWidthTypeId = widthType => {
  switch (widthType) {
    case WIDTH_TYPES.PIXEL:
      return 1
    case WIDTH_TYPES.PERCENTAGE:
      return 2
    default:
      return 3
  }
}

const convertBool = boolValue => {
  return boolValue == "true" || boolValue == 1 || boolValue == true ? 1 : 0
}

const convertAPIBool = apiBoolValue => {
  return apiBoolValue == 1 ? true : false
}
